<template>
  <v-combobox
      :loading="isLoading"
      item-value="key"
      item-text="value"
      :items="organizers"
      :value="current"
      :error-messages="errorMessages"
      :label="label"
      :readonly="readonly"
      :search-input.sync="search"
      :clearable="!readonly"
      return-object
      prepend-icon="person"
      eager
      dense
      @change="change">
    <template v-slot:prepend-inner>
      <v-icon
          v-if="required"
          small
          left
          :color="requiredColor">
        *
      </v-icon>
    </template>
  </v-combobox>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    props: {
      value: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      errorMessages: Array,
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        search: ''
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        users: state => (state[USER_MANAGEMENT.STATE.ORGANIZERS] || [])
      }),
      organizers () {
        return this.users.map(u => (
          {
            key: u.userId,
            value: `${u.contactPerson} (${u.organizationShortName} ${u.inn})`
          }))
      },
      current () {
        const vm = this
        return vm.organizers.find(u => u.key === vm.value)
      },
      filteredItems () {
        const vm = this
        if (vm.readonly) {
          return []
        }
        let filteredItems = vm.organizers
        if (vm.search &&
          (!vm.current || vm.current.value !== vm.search)) {
          filteredItems = filteredItems.filter(o => o.value.includes(vm.search))
        }
        if (vm.current && vm.current.key) {
          filteredItems = filteredItems.filter(o => o.key !== vm.current.key)
        }
        return filteredItems
      }
    },
    created () {
      this.getAllOrganizers()
    },
    destroyed () {
      this.clearAllOrganizersAction()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getAllOrganizersAction: USER_MANAGEMENT.ACTIONS.GET_ALL_ORGANIZERS,
        clearAllOrganizersAction: USER_MANAGEMENT.ACTIONS.CLEAR_ALL_ORGANIZERS
      }),
      getAllOrganizers: async function (contactPerson) {
        try {
          this.isLoading = true
          await this.getAllOrganizersAction({
            contactPerson: contactPerson || ''
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      change: function (user) {
        this.$emit('input', user ? user.key : null)
      }
    }
  }
</script>
